import {
  SURVEY_FETCH_SUCCESS,
  SURVEY_FETCH_REQUEST,
  SURVEY_FETCH_NEXT_PAGE_SUCCESS,
  SURVEY_PREVIOUS_PAGE,
  SURVEY_SET_PREV_PAGE,
  SURVEY_SET_PREV_PAGE_POP_PAGE,
} from '../../actions/types/activeProject';
import createReducer from '../createReducer';

const initialState = [];

const getLastQuestionNumber = (page, items, currentLastQuestionNumber) => {
  let lastQuestionNumber = currentLastQuestionNumber;
  let i = -1;
  if (page.items) {
    for (let i = page.items.length - 1; i >= 0; i--) {
      const item = items[page.items[i]] || {};
      if (item.questionNumberForSurvey !== undefined) {
        lastQuestionNumber = item.questionNumberForSurvey;
        break;
      }
    }
    return lastQuestionNumber;
  }
};

export default createReducer(initialState, {
  [SURVEY_FETCH_REQUEST]() {
    return initialState;
  },
  [SURVEY_FETCH_SUCCESS](state, action) {
    const { items, pages, pageFrontendId } = action.payload;
    const page = { ...pages[pageFrontendId] };
    page.lastQuestionNumber = getLastQuestionNumber(page, items);
    return [page];
  },
  [SURVEY_FETCH_NEXT_PAGE_SUCCESS](state, action) {
    const { items, pages, pageFrontendId, doNotPushNewPage } = action.payload;
    const page = { ...pages[pageFrontendId] };
    page.lastQuestionNumber = getLastQuestionNumber(page, items, state[state.length - 1].lastQuestionNumber);
    if (doNotPushNewPage) {
      const newState = [...state];
      newState[newState.length - 1] = page;
      return newState;
    }
    return [...state, page];
  },
  [SURVEY_SET_PREV_PAGE](state, action) {
    const { items, page } = action.payload;
    const newState = [...state];
    newState.pop();
    page.lastQuestionNumber = getLastQuestionNumber(page, items, newState[newState.length - 1].lastQuestionNumber);
    newState[newState.length - 1] = page;
    return newState;
  },
  [SURVEY_SET_PREV_PAGE_POP_PAGE](state, action) {
    return [...state.slice(0, state.length - 1)];
  },
  [SURVEY_PREVIOUS_PAGE](state) {
    return [...state.slice(0, state.length - 1)];
  },
});
